import { Dispatch } from 'react';

import {
  getCityFromGeolocation,
  getGeolocation,
} from '../../services/geolocation';
import {
  getRelatedBuildings,
  getSuggestedBuildings,
  SuggestedBuildings,
  SuggestedBuildingsParams,
} from '../../services/search';
import { captureException } from '../../services/sentry';
import { GetUnitParams, getUnits, Unit } from '../../services/units';
import {
  ActionInterface,
  dispatcher,
  generateActions,
} from '../../utils/redux';
import { toQueryString } from '../../utils/url';

export enum SearchActions {
  getSuggestedBuildingsStart = '[SEARCH]:GET_SUGGESTED_BUILDINGS:START',
  getSuggestedBuildingsSuccess = '[SEARCH]:GET_SUGGESTED_BUILDINGS:SUCCESS',
  getSuggestedBuildingsError = '[SEARCH]:GET_SUGGESTED_BUILDINGS:ERROR',
  getStaticSuggestedBuildingsStart = '[SEARCH]:GET_STATIC_SUGGESTED_BUILDINGS:START',
  getStaticSuggestedBuildingsSuccess = '[SEARCH]:GET_STATIC_SUGGESTED_BUILDINGS:SUCCESS',
  getStaticSuggestedBuildingsError = '[SEARCH]:GET_STATIC_SUGGESTED_BUILDINGS:ERROR',
  searchUnitsStart = '[SEARCH]:SEARCH_UNITS:START',
  searchUnitsSuccess = '[SEARCH]:SEARCH_UNITS:SUCCESS',
  searchUnitsError = '[SEARCH]:SEARCH_UNITS:ERROR',
  setResults = '[SEARCH]:SET_RESULTS:ERROR',
}

const searchActionsMap: {
  [key: string]: SearchActions;
} = SearchActions as any;

export function DoGetSuggestedBuildings() {
  const [start, success, error] = generateActions<
    SearchActions,
    SuggestedBuildings
  >('getStaticSuggestedBuildings', searchActionsMap);
  return async (d: Dispatch<ActionInterface<SearchActions>>) => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    let city = '';
    try {
      city = getCityFromGeolocation(await getGeolocation());
    } catch (e) {
      captureException(e);
    }
    try {
      const response = await getSuggestedBuildings(city);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      return dispatch(error)(errors.toString());
    }
  };
}

export function DoGetRelatedBuildings(
  buildingId?: number,
  params?: SuggestedBuildingsParams
) {
  const [start, success, error] = generateActions<
    SearchActions,
    SuggestedBuildings
  >('getSuggestedBuildings', searchActionsMap);
  return async (d: Dispatch<ActionInterface<SearchActions>>) => {
    const dispatch = dispatcher(d as any);
    dispatch(start)();
    try {
      const response = await getRelatedBuildings(buildingId || 1527, params);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      return dispatch(error)(errors.toString());
    }
  };
}

const searchStart = (params: GetUnitParams) => {
  return {
    payload: toQueryString(params),
    type: SearchActions.searchUnitsStart,
  };
};

export function DoSearchUnits(params: GetUnitParams) {
  const [, success, error] = generateActions<SearchActions, Unit[]>(
    'searchUnits',
    searchActionsMap
  );
  return async (d: Dispatch<ActionInterface<SearchActions>>) => {
    const dispatch = dispatcher(d as any);
    dispatch(searchStart)();
    try {
      const response = await getUnits(params);
      dispatch(success)(response);
      return response;
    } catch (e) {
      const errors = captureException(e);
      return dispatch(error)(errors.toString());
    }
  };
}

export function DoSetResults({
  units,
  query,
  searchOffset,
}: {
  units: Unit[];
  query: string;
  searchOffset: number;
}) {
  return async (d: Dispatch<ActionInterface<SearchActions>>) => {
    const dispatch = dispatcher(d as any);

    const actionCreator = ({
      units,
      query,
      searchOffset,
    }: {
      units: Unit[];
      query: string;
      searchOffset: number;
    }) => ({
      payload: { query, searchOffset, units },
      type: SearchActions.setResults,
    });
    dispatch(actionCreator)({ query, searchOffset, units });
  };
}
